/**
 * Identifies whether an element is the last one in an array.
 *
 * @param index The index of the element to check, with 0 as the first element.
 * @param length The number of elements in the array.
 * @returns True if the element is the last one in the array, false otherwise.
 */
export function isLastArrayElement(index: number, length: number): boolean {
  return index + 1 === length;
}

/**
 * Toggles the selection state of an item in a list of selected row IDs.
 * Uses Set for efficient operations with large datasets.
 *
 * @param selectedRowIds - Array of currently selected row IDs
 * @param itemId - The ID of the item to toggle
 * @returns A new array with the toggled selection state
 */
export function toggleItemSelection(
  selectedRowIds: string[],
  itemId: string
): string[] {
  const selectedSet = new Set(selectedRowIds);
  if (selectedSet.has(itemId)) {
    selectedSet.delete(itemId);
  } else {
    selectedSet.add(itemId);
  }
  return Array.from(selectedSet);
}
